import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Analytics from '@ublend-npm/aula-analytics';
import List, {
  ListItem,
  ListItemContent,
  ListItemPrimaryText,
  ListItemSecondaryText,
  RightDecorations,
  RightDecoration,
} from '$components/List';

import hasGrade from '$utils/hasGrade';

import * as TYPES from '$variables/types';
import getAssignmentMappingsSubtitle from '$utils/getAssignmentMappingsSubtitle';
import AssignmentMappingsViewModal from '$components/AssignmentMappingsViewModal';
import GradeLabel from '$components/GradeLabel';
import { OPEN_ASSESSMENT_ITEM_MODAL } from '$variables/analyticsEvents';

import { Wrapper } from './AssessmentItemsView.styled';

const AssessmentItemsView = ({
  assessmentItems,
  assignments,
  viewAs,
  spaceId,
}) => {
  const [mapAssignmentModalVisible, setMapAssignmentModalVisible] =
    useState(false);
  const [selectedAssessmentItem, setSelectedAssessmentItem] = useState(null);

  const handleClose = () => {
    setMapAssignmentModalVisible(false);
    setSelectedAssessmentItem(null);
  };

  const handleOpen = (item) => () => {
    setSelectedAssessmentItem(item);
    setMapAssignmentModalVisible(true);

    Analytics.track({
      event: OPEN_ASSESSMENT_ITEM_MODAL,
      assessmentItemId: item.id,
    });
  };

  return (
    !!assessmentItems.length && (
      <Wrapper>
        <List headerText="Assessment items" testId="assessment-items-list">
          {assessmentItems.map((item) => {
            const { id, title, mappedAssignments = [], studentGrade } = item;

            return (
              <ListItem key={id} onClick={handleOpen(item)}>
                <ListItemContent>
                  <ListItemPrimaryText>{title}</ListItemPrimaryText>
                  <ListItemSecondaryText>
                    {getAssignmentMappingsSubtitle(mappedAssignments)}
                  </ListItemSecondaryText>
                </ListItemContent>
                <RightDecorations>
                  {hasGrade(studentGrade) && (
                    <RightDecoration>
                      <GradeLabel grade={studentGrade.displayGrade} />
                    </RightDecoration>
                  )}
                </RightDecorations>
              </ListItem>
            );
          })}
        </List>
        {selectedAssessmentItem && (
          <AssignmentMappingsViewModal
            open={mapAssignmentModalVisible}
            onClose={handleClose}
            assignments={assignments}
            assessmentItem={selectedAssessmentItem}
            viewAs={viewAs}
            spaceId={spaceId}
          />
        )}
      </Wrapper>
    )
  );
};

AssessmentItemsView.propTypes = {
  assessmentItems: PropTypes.arrayOf(TYPES.AssessmentItem).isRequired,
  assignments: PropTypes.arrayOf(TYPES.Assignment).isRequired,
  viewAs: TYPES.ViewAs.isRequired,
  spaceId: PropTypes.string.isRequired,
};

export default AssessmentItemsView;
